/* =========================================================================
   Prototyp Onlineshop Solar – Amortisationsrechner
   Läuft nur, wenn die Rechner-Section auf der Seite vorhanden ist.
   ========================================================================= */
(function () {
  function init() {
    const $ = (id) => document.getElementById(id);
    if (!$('res-payback')) return;

    const CO2_PER_KWH = 0.38, HORIZON = 20, MAXSEARCH = 40;
    const de0 = (n) => Math.round(n).toLocaleString('de-DE');
    const eur = (n) => de0(n) + ' €';
    const kwh = (n) => de0(n) + ' kWh';
    const num = (id, def) => { const el = $(id); if (!el) return def; const v = parseFloat(String(el.value).replace(',', '.')); return isFinite(v) ? v : def; };

    [['in-area', 'rg-area'], ['in-cost', 'rg-cost'], ['in-feed', 'rg-feed'], ['in-kwp', 'rg-kwp']].forEach(function (pair) {
      const n = $(pair[0]), r = $(pair[1]);
      if (!n || !r) return;
      n.addEventListener('input', function () { r.value = Math.min(r.max, Math.max(r.min, n.value || r.min)); calc(); });
      r.addEventListener('input', function () { n.value = r.value; calc(); });
    });
    ['in-wpm2', 'in-yield', 'in-self', 'in-price', 'in-degr', 'in-priceinc'].forEach(function (id) {
      const el = $(id); if (el) el.addEventListener('input', calc);
    });

    function calc() {
      const area = Math.max(0, num('in-area', 4));
      const cost = Math.max(0, num('in-cost', 899));
      const feedCt = Math.max(0, num('in-feed', 8));
      const wpm2 = Math.max(1, num('in-wpm2', 200));
      const yieldK = Math.max(0, num('in-yield', 950));
      const self = Math.min(1, Math.max(0, num('in-self', 65) / 100));
      const priceCt = Math.max(0, num('in-price', 35));
      const degr = Math.max(0, num('in-degr', 0.5) / 100);
      const inc = Math.max(0, num('in-priceinc', 3) / 100);

      /* Zwei Wege zur Anlagengroesse, dieselbe Rechnung dahinter.
         Auf der Startseite ist nur die Balkonflaeche bekannt, daraus wird
         geschaetzt. Auf einer Produktseite steht die Nennleistung im
         Datenblatt – dort liefert die Section ein Feld #in-kwp, und das
         gewinnt. Eine zweite Rechenlogik fuer die Produktseite waere eine
         zweite Wahrheit gewesen; auf der Startseite gibt es das Feld nicht,
         sie laeuft unveraendert weiter. */
      const kWp = $('in-kwp') ? Math.max(0, num('in-kwp', 1)) : area * wpm2 / 1000;
      const gen1 = kWp * yieldK;
      if ($('hint-area')) $('hint-area').textContent = '≈ ' + kWp.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kWp installierte Leistung';

      const self1 = gen1 * self, feed1 = gen1 * (1 - self);
      const save1 = self1 * priceCt / 100;
      const feedEUR1 = feed1 * feedCt / 100;
      const total1 = save1 + feedEUR1;

      let cum = 0, payback = Infinity, profitH = -cost;
      for (let tYear = 1; tYear <= MAXSEARCH; tYear++) {
        const gen = gen1 * Math.pow(1 - degr, tYear - 1);
        const price = priceCt * Math.pow(1 + inc, tYear - 1);
        const benefit = gen * self * price / 100 + gen * (1 - self) * feedCt / 100;
        const prev = cum; cum += benefit;
        if (payback === Infinity && cum >= cost && benefit > 0) payback = (tYear - 1) + (cost - prev) / benefit;
        if (tYear <= HORIZON) profitH += benefit;
      }

      if (!isFinite(payback) || total1 <= 0) {
        $('res-payback').innerHTML = '&gt; ' + MAXSEARCH + ' <small>Jahre</small>';
        $('res-payback-sub').textContent = 'Mit diesen Werten nicht wirtschaftlich';
        $('res-bar').style.width = '100%';
      } else {
        const whole = Math.floor(payback);
        let months = Math.round((payback - whole) * 12);
        let wy = whole; if (months === 12) { wy++; months = 0; }
        $('res-payback').innerHTML = payback.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' <small>Jahre</small>';
        $('res-payback-sub').textContent = '≈ ' + wy + ' Jahre' + (months ? ' ' + months + ' Monate' : '');
        $('res-bar').style.width = Math.min(100, payback / HORIZON * 100) + '%';
      }

      $('res-kwp').textContent = kWp.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kWp';
      $('res-kwh').textContent = kwh(gen1);
      $('res-self').textContent = eur(save1);
      $('res-feed').textContent = eur(feedEUR1);
      $('res-total').textContent = eur(total1);
      $('res-profit20').textContent = (profitH >= 0 ? '+' : '−') + eur(Math.abs(profitH));
      $('res-co2').textContent = de0(gen1 * CO2_PER_KWH) + ' kg';
      $('res-bar-cap').textContent = HORIZON + ' Jahre';
    }

    calc();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
